export const ENDPOINTS = {
    getAllBanks: (currency = "NGN") =>
        `/v1/wallets/get_all_banks/all?currencyFrom=${currency}&currencyTo=${currency}`,
    verifyAccount: () => `/v1/wallets/verifyBankDetail`,
    getTransactionFee: "/v1/wallets/transferFees",
    transferFunds: "/v1/wallets/transfer",
    internationalTransfer: "/v1/wallets/transfer_request",
    verifyPin: "/v1/users/verify-pin",
    saveBeneficiary: "/v1/beneficiary",
    saveBeneficiaryStatus: "/v1/beneficiary/saved-status",
    getBeneficiary: (currency) => `/v1/beneficiary${currency ? `?currency=${currency}` : ""}`,
    getInvoiceSummary: `/v1/invoice/stat`,
    getAllInvoice: `/v1/invoice`,
    getAllWallets: `/v1/wallets/account`,
    getSingleInvoice: (id) => `/v1/invoice/${id}`,
    getAllUsers: (type = "all") => `/v1/flex/users${type === "all" ? "" : `/${type}`}`,
    acceptUsers: (userId) => `/v1/flex/users/incoming/${userId}`,
    deleteUserFromNetwork: (userId) => `/v1/flex/user/${userId}`,
    getSingleUser: (id) => `v1/flex/list-user/${id}`,
    getStats: "v1/flex/order/stat",
    getSingleFlexOrder: (id) => `v1/flex/order/${id}`,
    updateLinkOrders: "/v1/flex/order/update/link",
    fetchAccounts: "/v1/invoice/all?type=flex",
    getKybCountries: "/v1/kyb/countries",
    getKybAvailableWallets: "/v1/kyb/available-wallets",
    checkPhoneVerification: (countryCode) =>
        `/v1/kyb/phone-verification/check?countryCode=${countryCode}`,
    createBusiness: `/v1/kyb/create`,
    updateBusinessAddress: (businessId) => `/v1/kyb/${businessId}/address`,
    updateBusinessDocuments: (businessId) => `/v1/kyb/${businessId}/documents`,
    updateBusinessFinancialInformation: (businessId) =>
        `/v1/kyb/${businessId}/financial-information`,
    addBusinessUbo: (businessId) => `/v1/kyb/add-ubo/${businessId}`,
    addBusinessDirector: (businessId) => `/v1/kyb/add-director/${businessId}`,
    requestKybVerification: "/v1/kyb/request-verification",
    getKybRequirementsSummary: (businessId) => `/v1/kyb/${businessId}/requirements-summary`,
    getBusinessById: (businessId) => `/v1/business/${businessId}`,
  markMaintenanceFeeInformationViewed: "/v1/business/maintenance-fee-information/viewed",
  getActiveMaintenanceFees: "/v1/business/maintenance-fees/active",
    switchCurrentBusiness: (businessId) => `/v1/business/current/${businessId}`,
    sendBusinessOtp: "/v1/business/send-otp",
    verifyBusinessOtp: "/v1/business/verify-otp",
    updateBusinessPhoneNumber: "/v1/business/update-phone-number",
    createInvoice: `/v1/invoice/create`,
    editInvoice: (id) => `/v1/invoice/${id}`,
    downloadInvoice: (id) => `/v1/invoice/download/${id}`,
    reminder: (id) => `/v1/invoice/reminder/${id}`,
    deleteInvoice: (id) => `/v1/invoice/${id}`,
    makeInvoicePayment: (id) => `/v1/invoice/make-payment/${id}`,
    rejectInvoice: (id) => `/v1/invoice/reject/${id}`,
    uploadBusinessDocuments: (businessId, businessType) =>
        `/v1/business/upload-business-documents/${businessId}?businessType=${businessType}`,
    financeSummary: "/v1/finance/summery",
    financeAll: "/v1/finance/all",
    createShipment: "/v1/flex/shipment",
    getAllCompletedOrders: (query) =>
        `/v1/flex/order/completed-orders?searchTerm=${
            query?.searchTerm
        }&limit=10&page=${1}&currency=${query?.currency}&startDate=''&endDate=''`,
    addShipmentDetails: (shipmentId) => `/v1/flex/shipment/led/${shipmentId}`,
    addPaymentDetails: (shipmentId) => `/v1/flex/shipment/${shipmentId}`,
    getAllShipments: (path) => `/v1/flex/shipment/${path}`,
    getAllAssignedShipments: `/v1/flex/shipment/assigned`,
    getShipmentsStats: "/v1/flex/shipment/stat",
    fetchShipmentStatus: (shipmentId) => `/v1/message/flex-shipment/${shipmentId}`,
    changeShipmentStatus: (shipmentId) => `/v1/flex/shipment/update-status/${shipmentId}`,
    cancelShipment: (shipmentId) => `/v1/flex/shipment/${shipmentId}`,
    duplicateShipment: `/v1/flex/shipment/duplicate`,
    getPlaceDetails: "/v1/utility/get-place-detail",
    uploadFileLink: "/v1/utility/upload-file",
    uploadShipmentDoc: (shipmentId) => `/v1/flex/shipment/uploadDocument/${shipmentId}`,
    changeShipperPaymentStatus: (shipmentId) => `/v1/flex/shipment/payment/${shipmentId}`,
    acceptOrRejectShipment: (shipmentId) => `/v1/flex/shipment/shipper/${shipmentId}`,
    duplicateInvoice: `/v1/invoice/duplicate`,
    receiverAcceptOrRejectShipment: (shipmentId) => `/v1/flex/shipment-receiver/${shipmentId}`,
    editShipment: `/v1/flex/shipment/shipment/edit`,
    editShipper: (shipmentId) => `/v1/flex/shipment/edit-shipper/${shipmentId}`,
    openWallet: `/v1/wallets/open-wallet`,
    financeCreditWallet: "/v1/finance/new/wallet",
    getAllFinancePay: "/v1/finance-pay/all",
    getAllInboundOrders: "/v1/flex/order/inbounds-orders",
    getAllOutboundOrders: "/v1/flex/order/outbounds-orders",
    getAllFinance: "/v1/finance/new/all",
    getAllGroupedFinance: "/v1/finance/new/all/grouped",
    getAllSingleFinance: (id) => `/v1/finance/new/${id}`,
  getRepaymentWallet: `/v1/finance/new/repayment-wallet`,
  getNewWallets: () => `/v1/finance/new/wallets`,
  accountWallets: () => `/v1/wallets/accounts`,
    cancelFinanceRequest: (id, type) =>
        type !== "payment" ? `/v1/finance/new/${id}/cancel` : `/v1/finance-pay/update/${id}`,
    deleteFinanceDraft: (id) => `/v1/finance/new/${id}/delete-draft`,
    getAllBusinessDocs: "/v1/finance/fetch_business_documents",
    getFinanceActivities: (id) => `/v1/finance/new/${id}/activities`,
  getFinanceActivitiesNewMethod: (id) => `/v1/activity/${id}`,
    uploadFinanceBusinessDocs: "/v1/finance/upload_finance_documents",
    cratePayableFinance: "/v1/finance/new/payables/create",
    createFinancePay: "/v1/finance-pay/create",
    crateReceivableFinance: "/v1/finance/new/receivables/create",
    createRepayLoan: (id) => `/v1/finance/new/${id}/repay`,
  RepayLoan: (id) => `/v1/finance/new/${id}/create-repayment`,
    crateInventoryFinance: "/v1/finance/new/inventory/create",
  cratePaymentFinance: "/v1/finance/new/payment/create",
    getStablecoinToFiatCurrencies: "/v1/wallets/stablecoin/get-currency",
    getPublicFinance: (id) => `/v1/finance/new/public/${encodeURIComponent(id)}`,
    publicFinanceAction: (id) => `/v1/finance/new/public/action/${encodeURIComponent(id)}`,
    addUserEndpoint: (id) => `/v1/flex/user/${id}`,
    cancelWalkThrough: `/v1/users/view-finance-workthrough`,
    downloadReceipt: ({ financeId, subLoanId }) =>
        `/v1/finance/new/repayment/receipt?financeId=${financeId}&subLoanId=${subLoanId}`,
  downloadPaymentReceipt: ({ paymentId }) => `/v1/finance-pay/payment/receipt?id=${paymentId}`,
  openingFees: "/v1/wallets/opening-fees"
};
